import z from 'zod';

export const visitSchema = z
	.object({
		id: z.string(),
		userId: z.string().optional(),
		siteId: z.string().optional(),
		zoneId: z.string().optional(),
		eventId: z.string().optional(),
		checkedInAt: z.coerce.date().optional(),
		checkedOutAt: z.coerce.date().nullable().optional(),
		status: z.enum(['checkedIn', 'checkedOut']).default('checkedIn'),
	})
	.describe('Visit');
